package com.karawek.core.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration

/**
 * Semantic span styles for inline text styling.
 */
object CoreSpanStyles {
    val inlineLink: SpanStyle
        @Composable get() = SpanStyle(
            color = CoreTheme.colors.primary,
            textDecoration = TextDecoration.Underline,
            fontWeight = FontWeight.Medium,
        )

    val emphasized: SpanStyle
        @Composable get() = SpanStyle(
            color = CoreTheme.colors.textPrimary,
            fontWeight = FontWeight.SemiBold,
        )
}
